import clsx from 'clsx';
import type { ReactNode } from 'react';
import styles from './Panel.module.css';

export interface PanelProps {
  readonly title?: string | undefined;
  readonly actions?: ReactNode | undefined;
  readonly children: ReactNode;
  readonly className?: string | undefined;
}

/** A titled section of a page on a quiet surface. */
export const Panel = ({ title, actions, children, className }: PanelProps) => (
  <section className={clsx(styles.panel, className)}>
    {(title || actions) && (
      <header className={styles.header}>
        {title && <h2 className={styles.title}>{title}</h2>}
        {actions && <div className={styles.actions}>{actions}</div>}
      </header>
    )}
    {children}
  </section>
);
